<template>
  <form
    class="callback-form callbackwidget-call-form"
    novalidate
    @submit.prevent="submitThis"
    :class="[device_platform, { horizontal: horizontal }, form_class]"
  >
    <div class="callback-form__container">
      <div class="callback-form__input-wrapper">
        <input
          name="tel"
          type="tel"
          class="callback-form__input"
          :class="[input_theme]"
          placeholder="Телефон"
          v-model="phone"
          ref="phone"
          v-mask
          :pattern="'.*[0-9]{1}.*[0-9]{3}.*[0-9]{3}.*[0-9]{4}'"
          required
        />
      </div>

      <button
        type="submit"
        :disabled="!agreed"
        class="callback-form__button button button_theme_primary"
        :class="[{ button_disabled: !agreed }, button_theme]"
        ref="submitter"
      >
        <span><slot></slot></span>
      </button>
    </div>

    <div class="agreement" v-if="CONSTANTS.need_agreement">
      <div class="agreement__checkbox">
        <checkbox v-model="acceptance">
          <slot name="agreement">
            <span class="agreement__text">
              <a href="./agreement.pdf" target="_blank" class="agreement__link">
                Согласен на обработку персональных данных
              </a>
            </span>
          </slot>
        </checkbox>
      </div>
    </div>
  </form>
</template>

<script>
import Mixin from "@/common/mixin";
import Mask from "@/common/mask";
import Checkbox from "../checkbox";

export default {
  name: "callback-input",
  components: { Checkbox },
  directives: { Mask },
  mixins: [Mixin],
  props: [
    "horizontal",
    "data",
    "form_class",
    "focusOnMount",
    "button_theme",
    "input_theme",
  ],
  data() {
    return {
      acceptance: true,
      phone: "",
    };
  },
  computed: {
    agreed() {
      return this.acceptance;
    },
  },
  mounted() {
    if (this.focusOnMount) {
      this.$refs.phone.focus();
    }
  },
  methods: {
    getAgreement(type) {
      this.$emit("getAgreement", type);
    },
    submitThis(event) {
      if (
        this.$refs.phone.validity.valueMissing ||
        !this.$refs.phone.validity.valid
      ) {
        this.$refs.phone.setCustomValidity("Введите номер телефона");
      }
      if (
        !this.$refs.phone.validity.valueMissing &&
        !this.$refs.phone.validity.patternMismatch
      ) {
        this.$refs.phone.setCustomValidity("");
      }

      const phoneOrigin = this.phone.replaceAll(/[() -]+/g, "");
      if (phoneOrigin !== "" && phoneOrigin.match(/([0-9])\1{9,}/g)) {
        this.$refs.phone.setCustomValidity("Введите корректный номер телефона");
      }

      if (this.agreed && this.$el.reportValidity()) {
        if (typeof ckForms !== "undefined") {
          ckForms.send(this.$el);
        }
        this.$emit("callBack", {
          phone: this.phone,
          data: this.data,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/constants.scss";

.mobile {
  .callback-form {
    &__container {
      align-items: center;
    }
  }

  &.contacts {
    .agreement {
      left: 0;
    }
  }
}

.callback-form {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  &__input-wrapper {
    position: relative;
    width: 100%;
  }

  &__input {
    width: 100%;
    height: 54px;
    text-align: center;
    font-size: 20px;
    color: $transparent-gray;
    background-color: $white;
    border: 1px solid $transparent-gray;
    outline: none;

    &::placeholder {
      font-weight: 400;
      font-size: 20px;
      color: $transparent-gray;
      padding: 0;
      overflow: visible;
    }

    &.transparent {
      border: none;
      background-color: transparent;
      color: $white;
      border-bottom: 1px solid $white;
    }
  }

  &__button {
    height: 54px;
    margin-top: 16px;
    width: 100%;
    font-size: 20px;

    &_disabled {
      background: #c2c2c2;
      cursor: default;
    }
  }
}

.agreement {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
  margin-top: 9px;

  &__text {
    font-family: "Nissan Brend", sans-serif;
    padding-left: 7px;
    font-size: 10px;
    text-align: left;
    color: $transparent-gray;
  }

  &__link {
    color: $transparent-gray;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.cta {
  .agreement {
    display: none;
  }
}
</style>
